<template>
  <Datatable
      entity="QrPayRequest"
      :parameters="{company: $route.query.company}"
      :onRowClick="onRowClick"
      :rowActions="[{text: 'datatable.display', method: onRowClick}]">
  </Datatable>
</template>

<script>
import Datatable from "@/components/Datatable.vue";

export default {
  name: "QrPaymentRequests",

  components: { Datatable },

  mounted() {
    this.$store.state.pageTitleTranslationKey = "qr_payment_request.title";
    this.$store.state.pageIcon = "/icon/low-level.svg";
  },

  methods: {
    onRowClick(row) {
      this.$router.push(this.$router.buildContext("/qr-payment-request", {id: row.id}));
    }
  }
}
</script>

<style scoped>

</style>
